import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useCart } from '../../Context/Cartcontext';
import { ToastContainer, toast } from 'react-toastify';
import { getImageUrl } from '../../utils/imageUtils.js';
import 'react-toastify/dist/ReactToastify.css';
import './NewArrivalView.css';

const NewArrivalView = () => {
  const { id } = useParams();
  const { addToCart } = useCart();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [addedToCart, setAddedToCart] = useState(false);
  
  const baseURL="https://backendweb.properteck.lk";

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await fetch(`${baseURL}/api/products/getproduct/${id}`);
        const data = await response.json();

        if (!response.ok || !data.success || !data.product) {
          throw new Error(data.message || 'Failed to fetch product');
        }

        if (data.product.type !== 'new_arrival') {
          throw new Error('This product is not a new arrival');
        }

        setProduct(data.product);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchProduct();
  }, [id]);

  const handleAddToCart = () => {
    if (product && product.stock > 0) {
      const cartItem = {
        id: product._id,
        name: product.name,
        price: product.offerPrice || product.regularPrice,
        regularPrice: product.regularPrice,
        offerPrice: product.offerPrice,
        imageUrl: product.imageUrl,
        stock: product.stock,
        type: 'newarrival'
      };

      addToCart(cartItem);
      setAddedToCart(true);
      toast.success(`${product.name} added to cart!`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
      });

      setTimeout(() => setAddedToCart(false), 2000);
    }
  };

  if (loading) {
    return (
      <>
        <div className="new-loading-container">
          <div className="new-loading-spinner"></div>
        </div>
        <ToastContainer />
      </>
    );
  }

  if (error) {
    return (
      <>
        <div className="new-error-container">
          <h3>Error</h3>
          <p>{error}</p>
        </div>
        <ToastContainer />
      </>
    );
  }

  if (!product) {
    return (
      <>
        <div className="new-not-found-container">
          <h3>Product not found</h3>
          <p>The requested new arrival product could not be found.</p>
        </div>
        <ToastContainer />
      </>
    );
  }

  const discountPercentage = product.regularPrice > 0 
    ? Math.round(((product.regularPrice - product.offerPrice) / product.regularPrice) * 100) 
    : 0;

  return (
    <>
      <div className="new-newarrival-view">
        <div className="new-newarrival-image">
          <div className="new-new-label">NEW ARRIVAL</div>
          {discountPercentage > 0 && (
            <div className="new-discount-label">{discountPercentage}% OFF</div>
          )}
          <img 
            src={getImageUrl(product.imageUrl)} 
            alt={product.name}
          />
        </div>

        <div className="new-newarrival-details">
          <h1>{product.name}</h1>
          
          <div className="new-newarrival-badge">
            <span>⭐ New Arrival</span>
          </div>

          <div className="new-product-features">
            <h3>Product Specifications</h3>
            <ul>
              {Array.isArray(product.description)
                ? product.description.map((item, idx) => <li key={idx}>{item}</li>)
                : <li>{product.description}</li>}
            </ul>
          </div>

          <div className="new-pricing">
            <h3>Regular Price: LKR {product.regularPrice?.toLocaleString()}</h3>
            <h3>Offer Price: LKR {product.offerPrice?.toLocaleString()}</h3>
            {discountPercentage > 0 && (
              <h3>Discount: {discountPercentage}% OFF</h3>
            )}
          </div>

          <div className="new-stock-status">
            <span className={product.stock > 0 ? "new-in-stock" : "new-out-of-stock"}>
              {product.stock > 0 ? "In Stock" : "Out of Stock"}
            </span>
          </div>

          {product.stock > 0 && (
            <button 
              className={`new-add-to-cart-btn ${addedToCart ? 'new-added' : ''}`}
              onClick={handleAddToCart}
              disabled={addedToCart}
            >
              {addedToCart ? 'Added to Cart ✓' : 'Add to Cart'}
            </button>
          )}

          {addedToCart && (
            <div className="new-cart-success-message">
              <p>✓ Product added to cart successfully!</p>
            </div>
          )}
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default NewArrivalView;